import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  HostListener,
  Output,
  EventEmitter
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { from, distinct } from 'rxjs';
import { EventDashboardApi } from '../../api/eventDashboardApi';
import { ProgramTypes } from '../../models/_enum-collections';
import { BlockPartnerReasons } from '../../models/block-partner-reasons-by-program.model';
import { CommonInputModel } from '../../models/common-input.model';
import { ConciergeStatus } from '../../models/concierge-status.model';
import { EngagementActivityGeographyStatus } from '../../models/engagement-activity-geography-status.model';
import { EngagementActivityStatus } from '../../models/engagement-activity-status.model';
import { EngagementEditInput } from '../../models/engagement-edit-input.model';
import { EngagementInput } from '../../models/engagement-input.model';
import { EngagementType } from '../../models/engagement-type.model';
import { Engagement } from '../../models/engagement.model';
import { EventType } from '../../models/event-type.model';
import { PartnerComplianceInfoEventAllocationData } from '../../models/partner-compliance-info-event-allocation-data.model';
import { PartnerComplianceInformation } from '../../models/partner-compliance-information.model';
import { PartnerFundstatus } from '../../models/partner-fund-status.model';
import { PartnerInformation } from '../../models/partner-information.model';
import { PartnerOneAreas } from '../../models/partner-one-areas.model';
import { PartnerOneCountries } from '../../models/partner-one-countries.model';
import {
  PartnerPaymentDetails,
  FiscalYear
} from '../../models/partner-payment-details.model';
import {
  PCInfoEventAllocationRequest,
  FiscalYearDropdown,
  QuarterDropDown
} from '../../models/pc-info-event-allocation-request.model';
import { PoeStatus } from '../../models/poe-status.model';
import { ProgramTypeName } from '../../models/program-type-name.model';
import { UpdateConciergeRequest } from '../../models/update-concierge-request.model';
import { AppConstants } from '../common/app-constants';
import { SettingsService } from '../common/settings.service';
import { CommonSharedModule } from '../common/shared.module';
import { EditComponent } from '../home/edit/edit.component';
import { DashboardService } from '../services/dashboard.service';
import { LocalStorageService } from '../services/local-storage-service';
import { OsmosisEditService } from '../services/osmosis-edit.service';
import { OsmosisService } from '../services/osmosis.service';
import { PaymentInformationComponent } from './payment-information/payment-information.component';

@Component({
  selector: 'app-partner-dashboard',
  templateUrl: './partner-dashboard.component.html',
  styleUrls: ['./partner-dashboard.component.scss'],
  standalone: true,
  imports: [EditComponent, PaymentInformationComponent, CommonSharedModule]
})
export class PartnerDashboardComponent implements OnInit {
  @ViewChild('ag', { static: false }) ag!: Table;
  @ViewChild('age', { static: false }) age!: Table;
  @ViewChild('eg', { static: false }) eg!: Table;
  @ViewChild('ap', { static: false }) ap!: Table;
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  @ViewChildren('aptak') appcomponents!: QueryList<MultiSelect>;

  @Output() refreshList = new EventEmitter();

  loading = false;
  loadingIcon = 'fa-circle-o-notch';

  engagements: Engagement[] = [];
  eligibleEng: Engagement[] = [];
  approvedEng: Engagement[] = [];

  isC3Customer: SelectItem[];
  isC3CustomerBool = false;
  totalRecordsEngGeography!: number;
  totalRecordsEngGeographyEligible!: number;
  tblPageNumberEngGeography!: number;
  tblPageNumberEngGeographyEligible!: number;

  totalRecordsEligibleEng!: number;
  tblPageNumberEligibleEng!: number;

  totalRecordsApprovedEng!: number;
  tblPageNumberApprovedEng!: number;

  selectedItem!: Engagement;
  engagementFilters!: EngagementInput;
  cols!: any[];
  engcols!: any[];
  currentDate!: Date;
  expDate!: Date;
  timeDiff!: number;
  diffDays!: number;

  dataViewRecsPerPage!: number;
  dataViewRecsPerPage2!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;

  tblPageNumber!: number;
  totalRecords!: number;

  currentPageInfo!: string;
  currentPageInfoEngGeography!: string;
  currentPageInfoEngGeographyEligible!: string;
  currentPageInfoEligible!: string;
  currentPageInfoApproved!: string;

  srchEngagements!: FormGroup;
  msgs: any[] = [];
  disableSrchButton!: boolean;
  showEngagements!: boolean;
  showPartnerPaymentInfo!: boolean;

  parFuStat!: PartnerFundstatus;
  engagementActivityStatus!: EngagementActivityStatus[];
  engActivitybyCountry: EngagementActivityGeographyStatus[] = [];
  engActivitybyCountryEligible: EngagementActivityGeographyStatus[] = [];
  partnerOrgName!: string;
  isC3partner!: boolean;
  isFttready!: boolean;
  isOptOutPartner!: boolean;
  isCoSellReady!: boolean;
  isManagePartner!: boolean;
  isMeetSspaRequirement!: boolean;
  sspaAndAnticorruptionStatus!: string;
  isCommunication!: boolean;
  isSecurity!: boolean;
  isC3SecurityPartner!: boolean;
  isC3TeamsPartner!: boolean;
  engaActStat!: EngagementActivityStatus;
  approvedAmount!: number;
  approvedAmountAtRisk!: number;
  requestedAmount!: number;
  eligibleAmountAtRisk!: number;
  c3englable!: string;

  requestedDataset: any;
  approvedDataset: any;

  loadEditComponent = false;
  editNav = false;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  srch!: string;
  partnerFundStatus!: PartnerFundstatus;
  showPartnerInfo!: boolean;
  partnerInformation!: PartnerInformation;
  engagementTypeDrpdwn!: EngagementType[];
  rows = [] as any;
  fengagementTypeDrpdwn: SelectItem[] = [];
  poeStatus!: PoeStatus[];
  poeStatusDrpdwn: SelectItem[] = [];
  poeStatusAppDrpdwn: SelectItem[] = [];
  partnerPaymentDetails!: PartnerPaymentDetails;
  showFullscreen = true;
  engagementEditInput!: EngagementEditInput;
  searchedMpnId!: number;
  programTypes!: ProgramTypeName[];
  fiscalYear!: FiscalYear[];
  minDate!: Date;
  maxDate!: Date;
  invalidDates!: Date[];
  showConcierge = false;
  isEditConcierge = false;
  conciergeStatuses!: ConciergeStatus[];
  conciergeData: UpdateConciergeRequest[] = [];
  dateTime = new Date();
  yearRange = '';
  formConcierge!: FormGroup;
  isDisableSaveConcierge = false;
  formPartnerCompliance: FormGroup;
  blockStatus = [
    { statusName: 'Not Blocked', statusValue: false },
    { statusName: 'Blocked', statusValue: true }
  ];
  mcapBlockReasons!: BlockPartnerReasons[];
  msspBlockReasons!: BlockPartnerReasons[];
  operatorBlockReasons!: BlockPartnerReasons[];
  eventsBlockReasons!: BlockPartnerReasons[];
  pmoNextStepStatus: SelectItem[] = [];
  isEditPartnerCompliance = false;
  isEditPartnerOneAllocation = true;
  tempStore: any;
  isMcapBlocked = false;
  isOperatorBlocked = false;
  isEventsBlocked = false;
  isMsspBlocked = false;
  isAreaSelected = false;
  isCountrySelected = false;
  msgsEngDetails: any;
  partnerComplianceDetail: PartnerComplianceInformation[] = [];
  loadingCompliance = false;
  isSaveComplianceDisabled = true;
  partnerOneAreas!: PartnerOneAreas[];
  partnerOneCountries!: PartnerOneCountries[];
  partnerOneCountriesOnArea!: PartnerOneCountries[];
  eventTypes!: EventType[];
  partnerOneId!: string;
  allocationDataRequest: PCInfoEventAllocationRequest = {
    partnerOneId: '',
    eventTypeId: -1,
    fiscalYear: 0,
    year: 0,
    quarter: 0,
    areaId: -1,
    countryId: -1
  };
  allocationData!: PartnerComplianceInfoEventAllocationData;
  fiscalYearData: FiscalYearDropdown[] = [];
  selectedFiscalYear!: FiscalYearDropdown;
  selectedArea!: PartnerOneAreas;
  selectedCountry!: PartnerOneCountries;
  selectedEventType!: EventType;
  qaurterDropdown: QuarterDropDown[] = [
    { quarterId: 1, quarterName: 'Q1' },
    { quarterId: 2, quarterName: 'Q2' },
    { quarterId: 3, quarterName: 'Q3' },
    { quarterId: 4, quarterName: 'Q4' }
  ];
  selectedQuarter!: QuarterDropDown;
  showPartnerOneAreas = false;
  showPartnerOneCountries = false;

  constructor(
    private ds: DashboardService,
    private ed: EventDashboardApi,
    private osm: OsmosisService,
    private osmEdit: OsmosisEditService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public settings: SettingsService,
    public localStorage: LocalStorageService
  ) {
    this.isC3Customer = [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' }
    ];
    this.dateTime.setDate(this.dateTime.getDate());
    this.yearRange =
      (new Date().getFullYear() - 230).toString() +
      ':' +
      new Date().getFullYear();

    this.formPartnerCompliance = this.formBuilder.group({
      isMcapBlocked: false,
      isOperatorBlocked: false,
      isMsspBlocked: false,
      isEventsBlocked: false,
      mcapBlockReason: '',
      operatorBlockReason: '',
      msspBlockReason: '',
      eventsBlockReason: '',
      setFiscalYear: 0,
      setQuarter: 0,
      setCountry: '',
      setArea: '',
      setEventType: 0,
      setLimit: ''
    });
    this.formPartnerCompliance.disable();
  }

  @HostListener('window:resize') onresize(): void {
    requestAnimationFrame(() => {
      const editEngagement = document
        ?.querySelector('#engagementEdit')
        ?.querySelector<HTMLElement>('[role="dialog"]');

      if (editEngagement) {
        editEngagement.style.width = '90%';
        editEngagement.style.height = '85%';
      }
    });
  }

  ngOnInit() {
    this.showFullscreen = this.localStorage.getFullscreenMode();
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.dataViewRecsPerPage2 = AppConstants.dataListRecsPerPage2;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.emptyRecordMsg = AppConstants.emptyRecordMsg;
    this.showEngagements = false;
    this.showPartnerInfo = false;

    if (this.engagementEditInput) {
      this.engagementEditInput = {
        showFullScreen: this.showFullscreen
      } as any;
    }

    this.engcols = [
      { field: 'partnerOneSubID', header: 'Partner One SubID' },
      { field: 'mpniDlist', header: 'MPNID List' },
      { field: 'c3Engagement', header: 'C3Engagement' },
      { field: 'country', header: 'Country' },
      { field: 'noOFEngagements', header: 'No Of Engagements' }
    ];

    this.cols = [
      { field: 'engagementId', header: 'Engagement ID' },
      { field: 'engagementType', header: 'Engagement Name' },
      { field: 'engagementSubType', header: 'Engagement Type' },
      { field: 'customerName', header: 'Customer Name' },
      { field: 'customerCountry', header: 'Customer Country' },
      { field: 'daysLeft', header: 'Days Left' },
      { field: 'engagementStatus', header: 'Status' },
      { field: 'amount', header: 'Funding Amount' },
      { field: 'expirationDate', header: 'Expiration Date' },

      { field: 'nominatedBy', header: 'Nominated By' },
      { field: 'poeStatus', header: 'POE Status' },
      { field: 'workshopScheduleDate', header: 'Workshop Date' }
    ];

    const mpnId = this.route.snapshot.queryParamMap.get('mpnId');

    this.srchEngagements = this.formBuilder.group({
      txtEngagementSrch: [
        mpnId ? mpnId : ''
      ],
      icos: [''],
      isC3CustomerBool: ['']
    });
    
    this.onConciergeFormGroup();
    this.getEngagementType();
    this.getPoeStatus();
    this.searchEngagements();
    this.onLoadProgramType();
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
    this.refreshList.emit(true);
  }

  getPartnerOneAreas() {
    if (!this.partnerOneId) {
      return;
    }

    this.loading = true;
    this.ds.getPartnerOneAreas(this.partnerOneId).subscribe(data => {
      this.partnerOneAreas = data;
      this.showPartnerOneAreas = true;
      this.getPartnerOneCountries();
    });
  }

  getPartnerOneCountries() {
    this.loading = true;
    this.ds.getPartnerOneCountries(this.partnerOneId).subscribe(data => {
      this.partnerOneCountries = data;
      this.partnerOneCountriesOnArea = data.filter(
        c => c.areaId == this.selectedArea.areaID
      );
      this.showPartnerOneCountries = true;
      this.loading = false;
    });
  }

  getCurrentFiscalYearAndQuarter() {
    this.loading = true;
    this.ds.getCurrentFiscalYearAndQuarter().subscribe(data => {
      this.selectedFiscalYear = data.currentFiscalYear;
      this.selectedQuarter = data.currentQuarter;
      this.fiscalYearData = data.fiscalYears;
      this.loading = false;
    });
  }

  getEventTypes() {
    this.loading = true;
    this.ed.getAllWorkshops().subscribe(data => {
      this.eventTypes = data;
      this.selectedEventType = data[0];
      this.loading = false;
    });
  }

  getPartnerOneAllocationData() {
    this.getCurrentFiscalYearAndQuarter();
    if (this.partnerOneId) {
      this.getPartnerOneAreas();
    }
    this.getEventTypes();
  }

  resetPartnerOneAllocationData() {
    this.selectedCountry = {
      areaId: -1,
      country: '',
      countryId: -1
    };

    this.selectedArea = {
      areaID: -1,
      area: '',
      areaFullName: ''
    };
    this.partnerOneCountriesOnArea = [];
    this.getPartnerOneAllocationData();
    this.allocationData = {
      partnrId: -1,
      quarterlimit: 0,
      fiscalYear: 0,
      eventsCount: 0,
      eventsRemainingCount: 0,
      quarter: 0
    };
    this.isAreaSelected = false;
    this.isCountrySelected = false;
  }

  loadPartnerBlockReasons() {
    this.ds.getPartnerBlockReasons().subscribe(data => {
      this.mcapBlockReasons = [];
      this.msspBlockReasons = [];
      this.operatorBlockReasons = [];
      this.eventsBlockReasons = [];

      data.forEach(d => {
        if (d.programTypeId == this.programType.Accelerator) {
          this.mcapBlockReasons.push({
            blockPartnerReasonId: d.blockPartnerReasonId,
            reasonDescription: d.reasonDescription
          });
        }
        if (d.programTypeId == this.programType.MSSP) {
          this.msspBlockReasons.push({
            blockPartnerReasonId: d.blockPartnerReasonId,
            reasonDescription: d.reasonDescription
          });
        }
        if (d.programTypeId == this.programType.Operator) {
          this.operatorBlockReasons.push({
            blockPartnerReasonId: d.blockPartnerReasonId,
            reasonDescription: d.reasonDescription
          });
        }
        if (d.programTypeId == this.programType.Events) {
          this.eventsBlockReasons.push({
            blockPartnerReasonId: d.blockPartnerReasonId,
            reasonDescription: d.reasonDescription
          });
        }
      });
    });
  }

  onPartnerComplianceFormGroup() {
    this.loadPartnerBlockReasons();
    this.partnerComplianceDetail = [
      {
        mpnId: this.searchedMpnId.toString().trim(),
        programTypeId: this.programType.Accelerator,
        isBlocked: false,
        blockPartnerReasonId: 0
      },
      {
        mpnId: this.searchedMpnId.toString().trim(),
        programTypeId: this.programType.Operator,
        isBlocked: false,
        blockPartnerReasonId: 0
      },
      {
        mpnId: this.searchedMpnId.toString().trim(),
        programTypeId: this.programType.MSSP,
        isBlocked: false,
        blockPartnerReasonId: 0
      },
      {
        mpnId: this.searchedMpnId.toString().trim(),
        programTypeId: this.programType.Events,
        isBlocked: false,
        blockPartnerReasonId: 0
      }
    ];

    this.ds
      .getPartnerComplianceInformation(this.searchedMpnId)
      .subscribe(data => {
        if (data.length > 0) {
          if (
            data.find(p => p.programTypeId === this.programType.Accelerator)
          ) {
            this.getComplianceDetails(
              data.find(
                p => p.programTypeId === this.programType.Accelerator
              ) as PartnerComplianceInformation,
              this.programType.Accelerator
            );
          }
          if (data.find(p => p.programTypeId === this.programType.Operator)) {
            this.getComplianceDetails(
              data.find(
                p => p.programTypeId === this.programType.Operator
              ) as PartnerComplianceInformation,
              this.programType.Operator
            );
          }
          if (data.find(p => p.programTypeId === this.programType.MSSP)) {
            this.getComplianceDetails(
              data.find(
                p => p.programTypeId === this.programType.MSSP
              ) as PartnerComplianceInformation,
              this.programType.MSSP
            );
          }
          if (data.find(p => p.programTypeId === this.programType.Events)) {
            this.getComplianceDetails(
              data.find(
                p => p.programTypeId === this.programType.Events
              ) as PartnerComplianceInformation,
              this.programType.Events
            );
          }
        }
        this.resetPartnerCompliance();
        this.initializeComplianceDropdown();
        this.loadingCompliance = false;
      });
  }

  oneventEventTypeChange($event) {
    this.selectedEventType = $event.value;
    this.allocationDataRequest.eventTypeId =
      this.selectedEventType.eventTypeId ?? -1;
    this.allocationDataRequest.fiscalYear =
      this.selectedFiscalYear.fiscalYearId;
    this.allocationDataRequest.year = this.selectedFiscalYear.year;
    this.allocationDataRequest.quarter = this.selectedQuarter.quarterId;
    this.allocationDataRequest.areaId = this.selectedArea.areaID;
    this.allocationDataRequest.countryId = this.selectedCountry.countryId;
    this.loadEventAllocationData();
  }

  oneventFiscalYearChange($event) {
    this.selectedFiscalYear = $event.value;
    this.allocationDataRequest.fiscalYear =
      this.selectedFiscalYear.fiscalYearId;
    this.allocationDataRequest.eventTypeId =
      this.selectedEventType.eventTypeId ?? -1;
    this.allocationDataRequest.quarter = this.selectedQuarter.quarterId;
    this.allocationDataRequest.areaId = this.selectedArea.areaID;
    this.allocationDataRequest.countryId = this.selectedCountry.countryId;
    this.allocationDataRequest.year = this.selectedFiscalYear.year;
    this.loadEventAllocationData();
  }

  oneventPartnerOneAreaChange($event) {
    this.selectedArea = $event.value;
    const data = this.partnerOneCountries;
    this.partnerOneCountriesOnArea = data.filter(
      c => c.areaId == this.selectedArea.areaID
    );
    this.allocationDataRequest.eventTypeId =
      this.selectedEventType.eventTypeId ?? -1;
    this.allocationDataRequest.areaId = this.selectedArea.areaID;
    this.allocationDataRequest.fiscalYear =
      this.selectedFiscalYear.fiscalYearId;
    this.allocationDataRequest.quarter = this.selectedQuarter.quarterId;

    this.allocationDataRequest.countryId = this.partnerOneCountriesOnArea[0]
      ? this.partnerOneCountriesOnArea[0].countryId
      : -1;
    this.allocationDataRequest.year = this.selectedFiscalYear.year;
    this.isAreaSelected = true;
  }

  oneventPartnerOneCountryChange($event) {
    this.selectedCountry = $event.value;
    this.allocationDataRequest.countryId = this.selectedCountry.countryId;
    this.allocationDataRequest.eventTypeId =
      this.selectedEventType.eventTypeId ?? -1;
    this.allocationDataRequest.areaId = this.selectedArea.areaID;
    this.allocationDataRequest.fiscalYear =
      this.selectedFiscalYear.fiscalYearId;
    this.allocationDataRequest.quarter = this.selectedQuarter.quarterId;
    this.allocationDataRequest.year = this.selectedFiscalYear.year;
    this.isCountrySelected = true;
    this.loadEventAllocationData();
  }

  oneventQuarterChange($event) {
    this.selectedQuarter = $event.value;
    this.allocationDataRequest.fiscalYear =
      this.selectedFiscalYear.fiscalYearId;
    this.allocationDataRequest.eventTypeId =
      this.selectedEventType.eventTypeId ?? -1;
    this.allocationDataRequest.quarter = this.selectedQuarter.quarterId;
    this.allocationDataRequest.year = this.selectedFiscalYear.year;
    this.allocationDataRequest.countryId = this.selectedCountry.countryId;
    this.allocationDataRequest.areaId = this.selectedArea.areaID;
    this.loadEventAllocationData();
  }

  loadEventAllocationData() {
    this.allocationDataRequest.partnerOneId = this.partnerOneId;
    if (this.isAreaSelected && this.isCountrySelected) {
      this.loading = true;
      this.ed
        .getPartnerComplianceAllocationData(this.allocationDataRequest)
        .subscribe(x => {
          if (x != null) {
            this.allocationData.partnrId = x.partnrId;
            this.allocationData.quarterlimit = x.quarterlimit;
            this.allocationData.fiscalYear = x.fiscalYear;
            this.allocationData.eventsCount = x.eventsCount;
            this.allocationData.eventsRemainingCount = x.eventsRemainingCount;
            this.allocationData.quarter = x.quarter;
          }
          this.loading = false;
        });
    }
  }

  initializeComplianceDropdown() {
    this.formPartnerCompliance.controls['isMcapBlocked'].setValue({
      statusValue: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Accelerator
      )?.isBlocked,
      statusName: this.blockStatus.find(
        obj =>
          obj.statusValue ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.Accelerator
          )?.isBlocked
      )?.statusName
    });
    this.formPartnerCompliance.controls['isOperatorBlocked'].setValue({
      statusValue: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Operator
      )?.isBlocked,
      statusName: this.blockStatus.find(
        obj =>
          obj.statusValue ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.Operator
          )?.isBlocked
      )?.statusName
    });
    this.formPartnerCompliance.controls['isMsspBlocked'].setValue({
      statusValue: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.MSSP
      )?.isBlocked,
      statusName: this.blockStatus.find(
        obj =>
          obj.statusValue ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.MSSP
          )?.isBlocked
      )?.statusName
    });
    this.formPartnerCompliance.controls['isEventsBlocked'].setValue({
      statusValue: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Events
      )?.isBlocked,
      statusName: this.blockStatus.find(
        obj =>
          obj.statusValue ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.Events
          )?.isBlocked
      )?.statusName
    });

    this.formPartnerCompliance.controls['mcapBlockReason'].setValue({
      blockPartnerReasonId: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Accelerator
      )?.blockPartnerReasonId,
      reasonDescription: this.mcapBlockReasons.find(
        x =>
          x.blockPartnerReasonId ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.Accelerator
          )?.blockPartnerReasonId
      )?.reasonDescription
    });
    this.formPartnerCompliance.controls['operatorBlockReason'].setValue({
      blockPartnerReasonId: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Operator
      )?.blockPartnerReasonId,
      reasonDescription: this.operatorBlockReasons.find(
        x =>
          x.blockPartnerReasonId ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.Operator
          )?.blockPartnerReasonId
      )?.reasonDescription
    });
    this.formPartnerCompliance.controls['msspBlockReason'].setValue({
      blockPartnerReasonId: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.MSSP
      )?.blockPartnerReasonId,
      reasonDescription: this.msspBlockReasons.find(
        x =>
          x.blockPartnerReasonId ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.MSSP
          )?.blockPartnerReasonId
      )?.reasonDescription
    });
    this.formPartnerCompliance.controls['eventsBlockReason'].setValue({
      blockPartnerReasonId: this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Events
      )?.blockPartnerReasonId,
      reasonDescription: this.eventsBlockReasons.find(
        x =>
          x.blockPartnerReasonId ==
          this.partnerComplianceDetail.find(
            p => p.programTypeId == this.programType.Events
          )?.blockPartnerReasonId
      )?.reasonDescription
    });
  }

  getComplianceDetails(
    data: PartnerComplianceInformation,
    programTypeId: ProgramTypes
  ) {
    const complianceDetail = this.partnerComplianceDetail.find(
      obj => obj.programTypeId === programTypeId
    );

    if (complianceDetail) {
      complianceDetail.isBlocked = data.isBlocked;
    }

    if (complianceDetail) {
      complianceDetail.blockPartnerReasonId = data.isBlocked
        ? data.blockPartnerReasonId
        : 0;
    }
  }

  onConciergeFormGroup() {
    this.formConcierge = this.formBuilder.group({
      programType: ['', [Validators.required]],
      conciergeDateOperator: [''],
      conciergeStatusOperator: [''],
      conciergeDateMSSP: [''],
      conciergeStatusMSSP: [''],
      conciergeDateEvents: [''],
      conciergeStatusEvents: ['']
    });
    this.formConcierge.disable();
  }

  isC3EventChange() {
    this.getEngagementType();
    this.getPoeStatus();
    this.searchEngagements();
  }

  resetEngGeography() {
    this.ag.reset();

    if (
      this.engActivitybyCountry === null ||
      this.engActivitybyCountry.length === 0
    ) {
      this.totalRecordsEngGeography = 0;
      this.currentPageInfoEngGeography = 'No Records Found';
    } else {
      this.totalRecordsEngGeography = this.engActivitybyCountry.length;
      if (
        this.totalRecordsEngGeography > 0 &&
        this.totalRecordsEngGeography > 10
      ) {
        this.currentPageInfoEngGeography =
          'Showing 1 - ' +
          1 * 10 +
          ' of ' +
          this.totalRecordsEngGeography +
          ' Records';
      }
      if (
        this.totalRecordsEngGeography > 0 &&
        this.totalRecordsEngGeography <= 10
      ) {
        this.currentPageInfoEngGeography =
          'Showing 1 - ' +
          this.totalRecordsEngGeography +
          ' of ' +
          this.totalRecordsEngGeography +
          ' Records';
      }
    }
  }

  resetEngGeographyEligible() {
    this.age.reset();

    if (
      this.engActivitybyCountryEligible === null ||
      this.engActivitybyCountryEligible.length === 0
    ) {
      this.totalRecordsEngGeographyEligible = 0;
      this.currentPageInfoEngGeographyEligible = 'No Records Found';
    } else {
      this.totalRecordsEngGeographyEligible =
        this.engActivitybyCountryEligible.length;
      if (
        this.totalRecordsEngGeographyEligible > 0 &&
        this.totalRecordsEngGeographyEligible > 10
      ) {
        this.currentPageInfoEngGeography =
          'Showing 1 - ' +
          1 * 10 +
          ' of ' +
          this.totalRecordsEngGeographyEligible +
          ' Records';
      }
      if (
        this.totalRecordsEngGeographyEligible > 0 &&
        this.totalRecordsEngGeographyEligible <= 10
      ) {
        this.currentPageInfoEngGeographyEligible =
          'Showing 1 - ' +
          this.totalRecordsEngGeographyEligible +
          ' of ' +
          this.totalRecordsEngGeographyEligible +
          ' Records';
      }
    }
  }

  resetEligibleList() {
    this.eg.reset();
    if (this.isC3CustomerBool === false) {
      this.eligibleEng = this.engagements.filter(
        sts => sts.engagementStatus === 'Eligible'
      );
    }
    if (this.isC3CustomerBool === true) {
      this.eligibleEng = this.engagements.filter(
        sts => sts.engagementStatus === 'Eligible' && sts.c3Engagement === 'Yes'
      );
    }

    if (this.eligibleEng === null || this.eligibleEng.length === 0) {
      this.totalRecordsEligibleEng = 0;
      this.currentPageInfoEligible = 'No Records Found';
    } else {
      this.totalRecordsEligibleEng = this.eligibleEng.length;
      if (
        this.totalRecordsEligibleEng > 0 &&
        this.totalRecordsEligibleEng > 10
      ) {
        this.currentPageInfoEligible =
          'Showing 1 - ' +
          1 * 10 +
          ' of ' +
          this.totalRecordsEligibleEng +
          ' Records';
      }
      if (
        this.totalRecordsEligibleEng > 0 &&
        this.totalRecordsEligibleEng <= 10
      ) {
        this.currentPageInfoEligible =
          'Showing 1 - ' +
          this.totalRecordsEligibleEng +
          ' of ' +
          this.totalRecordsEligibleEng +
          ' Records';
      }
    }
  }

  resetApprovedList() {
    this.appcomponents['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.ap) {
      this.ap.filter('', 'poeStatus', 'in');
      this.ap.reset();
    }

    if (this.isC3CustomerBool === false) {
      this.approvedEng = this.engagements.filter(
        sts => sts.engagementStatus === 'Approved'
      );
    }
    if (this.isC3CustomerBool === true) {
      this.approvedEng = this.engagements.filter(
        sts => sts.engagementStatus === 'Approved' && sts.c3Engagement === 'Yes'
      );
    }
    if (this.approvedEng === null || this.approvedEng.length === 0) {
      this.totalRecordsApprovedEng = 0;
      this.currentPageInfoApproved = 'No Records Found';
    } else {
      this.totalRecordsApprovedEng = this.approvedEng.length;
      if (
        this.totalRecordsApprovedEng > 0 &&
        this.totalRecordsApprovedEng > 10
      ) {
        this.currentPageInfoApproved =
          'Showing 1 - ' +
          1 * 10 +
          ' of ' +
          this.totalRecordsApprovedEng +
          ' Records';
      }
      if (
        this.totalRecordsApprovedEng > 0 &&
        this.totalRecordsApprovedEng <= 10
      ) {
        this.currentPageInfoApproved =
          'Showing 1 - ' +
          this.totalRecordsApprovedEng +
          ' of ' +
          this.totalRecordsApprovedEng +
          ' Records';
      }
    }
  }

  resetNominationsList() {
    if (this.dt) {
      this.dt.reset();
    }

    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'engagementType', 'in');
      this.dt.filter('', 'poeStatus', 'in');
      this.dt.reset();
    }

    if (this.engagements === null || this.engagements.length === 0) {
      this.msgs = [];
      this.msgs.push({
        severity: 'warn',
        detail: 'No Records Found'
      });
      this.totalRecords = 0;
    } else {
      this.totalRecords = this.engagements.length;
    }
    if (this.totalRecords === 0) {
      this.showEngagements = false;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.showEngagements = true;
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  getPoeStatus() {
    this.osmEdit.getPoeStatusDropDown().subscribe(PTList => {
      this.poeStatus = PTList;
      for (const item of this.poeStatus) {
        const poeStatusDrpdwn: SelectItem = {
          label: item.poeStatusName,
          value: item.poeStatusName
        };
        this.poeStatusDrpdwn.push(poeStatusDrpdwn);
        this.poeStatusAppDrpdwn.push(poeStatusDrpdwn);
      }
    });
  }
  getEngagementType() {
    this.osmEdit.getEngagementTypeDropDown().subscribe(PTList => {
      this.engagementTypeDrpdwn = PTList;
      from(this.engagementTypeDrpdwn)
        .pipe(distinct(d => d.engagementName))
        .subscribe(r => this.rows.push(r));
      for (const item of this.rows) {
        const engagementTypeDrpdwn: SelectItem = {
          label: item.engagementName,
          value: item.engagementName
        };
        this.fengagementTypeDrpdwn.push(engagementTypeDrpdwn);
      }
    });
  }

  numericOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  pageChangeEngGeography(e) {
    this.tblPageNumberEngGeography = e.first;
    if (e.first + 15 > this.totalRecordsEngGeography) {
      this.currentPageInfoEngGeography =
        'Showing ' +
        (this.tblPageNumberEngGeography + 1) +
        ' - ' +
        this.totalRecordsEngGeography +
        ' of ' +
        this.totalRecordsEngGeography +
        ' Records';
    } else {
      this.currentPageInfoEngGeography =
        'Showing ' +
        (this.tblPageNumberEngGeography + 1) +
        ' - ' +
        (this.tblPageNumberEngGeography + 15) +
        ' of ' +
        this.totalRecordsEngGeography +
        ' Records';
    }
  }
  pageChangeEngGeographyEligible(e) {
    this.tblPageNumberEngGeographyEligible = e.first;
    if (e.first + 15 > this.totalRecordsEngGeographyEligible) {
      this.currentPageInfoEngGeographyEligible =
        'Showing ' +
        (this.tblPageNumberEngGeographyEligible + 1) +
        ' - ' +
        this.totalRecordsEngGeographyEligible +
        ' of ' +
        this.totalRecordsEngGeographyEligible +
        ' Records';
    } else {
      this.currentPageInfoEngGeographyEligible =
        'Showing ' +
        (this.tblPageNumberEngGeographyEligible + 1) +
        ' - ' +
        (this.tblPageNumberEngGeographyEligible + 15) +
        ' of ' +
        this.totalRecordsEngGeographyEligible +
        ' Records';
    }
  }

  pageChangeEligible(e) {
    this.tblPageNumberEligibleEng = e.first;
    if (e.first + 15 > this.totalRecordsEligibleEng) {
      this.currentPageInfoEligible =
        'Showing ' +
        (this.tblPageNumberEligibleEng + 1) +
        ' - ' +
        this.totalRecordsEligibleEng +
        ' of ' +
        this.totalRecordsEligibleEng +
        ' Records';
    } else {
      this.currentPageInfoEligible =
        'Showing ' +
        (this.tblPageNumberEligibleEng + 1) +
        ' - ' +
        (this.tblPageNumberEligibleEng + 15) +
        ' of ' +
        this.totalRecordsEligibleEng +
        ' Records';
    }
  }

  pageChangeApproved(e) {
    this.tblPageNumberApprovedEng = e.first;
    if (e.first + 15 > this.totalRecordsApprovedEng) {
      this.currentPageInfoApproved =
        'Showing ' +
        (this.tblPageNumberApprovedEng + 1) +
        ' - ' +
        this.totalRecordsApprovedEng +
        ' of ' +
        this.totalRecordsApprovedEng +
        ' Records';
    } else {
      this.currentPageInfoApproved =
        'Showing ' +
        (this.tblPageNumberApprovedEng + 1) +
        ' - ' +
        (this.tblPageNumberApprovedEng + 15) +
        ' of ' +
        this.totalRecordsApprovedEng +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilterEngGeography(event) {
    this.totalRecordsEngGeography = event.filteredValue.length;
    if (this.totalRecordsEngGeography === 0) {
      this.currentPageInfoEngGeography = 'No Record Found';
    }
    if (
      this.totalRecordsEngGeography > 0 &&
      this.totalRecordsEngGeography > 15
    ) {
      this.currentPageInfoEngGeography =
        'Showing 1 - ' +
        1 * 15 +
        ' of ' +
        this.totalRecordsEngGeography +
        ' Records';
    }
    if (
      this.totalRecordsEngGeography > 0 &&
      this.totalRecordsEngGeography <= 15
    ) {
      this.currentPageInfoEngGeography =
        'Showing 1 - ' +
        this.totalRecordsEngGeography +
        ' of ' +
        this.totalRecordsEngGeography +
        ' Records';
    }
  }
  applyFilterEngGeographyEligible(event) {
    this.totalRecordsEngGeographyEligible = event.filteredValue.length;
    if (this.totalRecordsEngGeographyEligible === 0) {
      this.currentPageInfoEngGeographyEligible = 'No Record Found';
    }
    if (
      this.totalRecordsEngGeographyEligible > 0 &&
      this.totalRecordsEngGeographyEligible > 15
    ) {
      this.currentPageInfoEngGeographyEligible =
        'Showing 1 - ' +
        1 * 15 +
        ' of ' +
        this.totalRecordsEngGeographyEligible +
        ' Records';
    }
    if (
      this.totalRecordsEngGeographyEligible > 0 &&
      this.totalRecordsEngGeographyEligible <= 15
    ) {
      this.currentPageInfoEngGeographyEligible =
        'Showing 1 - ' +
        this.totalRecordsEngGeographyEligible +
        ' of ' +
        this.totalRecordsEngGeographyEligible +
        ' Records';
    }
  }

  applyFilterEligible(event) {
    this.totalRecordsEligibleEng = event.filteredValue.length;
    if (this.totalRecordsEligibleEng === 0) {
      this.currentPageInfoEligible = 'No Record Found';
    }
    if (this.totalRecordsEligibleEng > 0 && this.totalRecordsEligibleEng > 15) {
      this.currentPageInfoEligible =
        'Showing 1 - ' +
        1 * 15 +
        ' of ' +
        this.totalRecordsEligibleEng +
        ' Records';
    }
    if (
      this.totalRecordsEligibleEng > 0 &&
      this.totalRecordsEligibleEng <= 15
    ) {
      this.currentPageInfoEligible =
        'Showing 1 - ' +
        this.totalRecordsEligibleEng +
        ' of ' +
        this.totalRecordsEligibleEng +
        ' Records';
    }
  }

  applyFilterApproved(event) {
    this.totalRecordsApprovedEng = event.filteredValue.length;
    if (this.totalRecordsApprovedEng === 0) {
      this.currentPageInfoApproved = 'No Record Found';
    }
    if (this.totalRecordsApprovedEng > 0 && this.totalRecordsApprovedEng > 15) {
      this.currentPageInfoApproved =
        'Showing 1 - 15 ' + ' of ' + this.totalRecordsApprovedEng + ' Records';
    }
    if (
      this.totalRecordsApprovedEng > 0 &&
      this.totalRecordsApprovedEng <= 15
    ) {
      this.currentPageInfoApproved =
        'Showing 1 - ' +
        this.totalRecordsApprovedEng +
        ' of ' +
        this.totalRecordsApprovedEng +
        ' Records';
    }
  }

  getPartnerInformation(src: string) {
    this.ds.getPartnerInformation(src).subscribe(partnerInformationOutput => {
      this.partnerInformation = partnerInformationOutput;
      if (this.partnerInformation !== null) {
        this.partnerOrgName = partnerInformationOutput.partnerOrgName || '';
        this.isC3partner = partnerInformationOutput.isC3partner || false;
        this.isFttready = partnerInformationOutput.isFttready || false;
        this.isCoSellReady = partnerInformationOutput.isCoSellReady || false;
        this.isManagePartner =
          partnerInformationOutput.isManagePartner || false;
        this.isMeetSspaRequirement =
          partnerInformationOutput.isMeetSspaRequirement || false;
        this.sspaAndAnticorruptionStatus =
          partnerInformationOutput.sspaAndAnticorruptionStatus || '';
        this.isC3SecurityPartner =
          partnerInformationOutput.isC3SecurityPartner || false;
        this.isC3TeamsPartner =
          partnerInformationOutput.isC3TeamsPartner || false;
        this.isCommunication =
          partnerInformationOutput.isCommunication || false;
        this.isSecurity = partnerInformationOutput.isSecurity || false;
        this.isOptOutPartner =
          partnerInformationOutput.isOptOutPartner || false;
        this.showPartnerInfo = true;
        this.partnerOneId = partnerInformationOutput.partnerOneId || '';
        this.getPartnerOneAllocationData();
      } else {
        this.showPartnerInfo = false;
        this.showConcierge = false;
      }
    });
  }

  getPartnerFundStatus(src: string) {
    this.ds.getPartnerFundStatus(src).subscribe(fundStatusOutput => {
      this.approvedAmount = fundStatusOutput.approvedAmount || -1;
      this.approvedAmountAtRisk = fundStatusOutput.approvedAmountAtRisk || -1;
      this.requestedAmount = fundStatusOutput.requestedAmount || -1;
      this.eligibleAmountAtRisk = fundStatusOutput.eligibleAmountAtRisk || -1;
    });
  }

  getEngagementActivityStatus(src: string) {
    this.ds.GetEngagementActivityStatus_V1(src).subscribe(engActivityOutput => {
      if (this.isC3CustomerBool === false) {
        this.engagementActivityStatus = engActivityOutput.filter(
          x => x.c3Engagement === 0
        );
      }
      if (this.isC3CustomerBool === true) {
        this.engagementActivityStatus = engActivityOutput.filter(
          x => x.c3Engagement === 1
        );
      }
    });
  }

  searchEngagements() {
    this.loading = true;
    this.resetPartnerOneAllocationData();
    this.showEngagements = false;
    this.showPartnerInfo = false;
    this.showPartnerPaymentInfo = false;
    this.showConcierge = false;
    this.isEditConcierge = false;
    this.isDisableSaveConcierge = false;
    this.isEditPartnerCompliance = false;
    this.isEditPartnerOneAllocation = false;
    this.isSaveComplianceDisabled = true;

    if (
      this.srchEngagements.controls['txtEngagementSrch'].value === '' ||
      this.srchEngagements.controls['txtEngagementSrch'].value === undefined ||
      this.srchEngagements.controls['txtEngagementSrch'].value === null
    ) {
      this.msgs = [];
      this.msgs.push({
        severity: 'warn',
        detail: 'Please enter PartnerID '
      });
      this.loading = false;
      this.disableSrchButton = false;
      this.showEngagements = false;
      this.showPartnerInfo = false;
      this.showPartnerPaymentInfo = false;
      this.showConcierge = false;
      this.isEditConcierge = false;
      this.currentPageInfo = 'No Records Found';

      return;
    } else {
      this.msgs = [];

      const srchInput: EngagementInput = {
        mpnid: this.srchEngagements.controls['txtEngagementSrch'].value
      };

      this.searchedMpnId =
        this.srchEngagements.controls['txtEngagementSrch'].value;
      this.onPartnerComplianceFormGroup();
      this.getPartnerInformation(
        this.srchEngagements.controls['txtEngagementSrch'].value
      );
      this.resetFormConcierge();
      this.getConciergeInformation();

      const commmonInputModel: CommonInputModel = {
        mpnid: srchInput.mpnid,
        programTypeId: 0,
        year: this.getCurrentFiscalYear().toString()
      };

      this.getPartnerPaymentDetails(commmonInputModel);
      this.getFiscalYear();
      this.ds
        .GetEngagementActivityGeographyStatus(
          this.srchEngagements.controls['txtEngagementSrch'].value,
          this.settings.AliasName || ''
        )
        .subscribe(countryOutput => {
          if (this.isC3CustomerBool === false) {
            this.engActivitybyCountry = countryOutput;
          }
          if (this.isC3CustomerBool === true) {
            this.engActivitybyCountry = countryOutput.filter(
              x => x.c3Engagement === 'Yes'
            );
          }
        });

      this.ds
        .GetEngagementActivityGeographyStatusEligible(
          this.srchEngagements.controls['txtEngagementSrch'].value,
          this.settings.AliasName || ''
        )
        .subscribe(countryOutput => {
          if (this.isC3CustomerBool === false) {
            this.engActivitybyCountryEligible = countryOutput;
          }
          if (this.isC3CustomerBool === true) {
            this.engActivitybyCountryEligible = countryOutput.filter(
              x => x.c3Engagement === 'Yes'
            );
          }
        });

      this.ds
        .getAllEngagements(
          this.srchEngagements.controls['txtEngagementSrch'].value
        )
        .subscribe(serviceOutput => {
          if (this.isC3CustomerBool === false) {
            this.engagements = serviceOutput;
          }
          if (this.isC3CustomerBool === true) {
            this.engagements = serviceOutput.filter(
              x => x.c3Engagement === 'Yes'
            );
          }
          if (this.engagements === null || this.engagements.length === 0) {
            this.msgs = [];
            this.msgs.push({
              severity: 'warn',
              detail: 'No Engagements Records Found'
            } as any);

            this.totalRecords = 0;
          } else {
            this.totalRecords = this.engagements.length;
          }
          if (this.totalRecords === 0) {
            this.showEngagements = false;
            this.currentPageInfo = 'No Records Found';
          } else {
            this.showEngagements = true;
            if (this.totalRecords > 0 && this.totalRecords > 20) {
              this.currentPageInfo =
                'Showing 1 - ' +
                1 * 20 +
                ' of ' +
                this.totalRecords +
                ' Records';
            }

            if (this.totalRecords > 0 && this.totalRecords <= 20) {
              this.currentPageInfo =
                'Showing 1 - ' +
                this.totalRecords +
                ' of ' +
                this.totalRecords +
                ' Records';
            }

            if (this.isC3CustomerBool === false) {
              this.eligibleEng = this.engagements.filter(
                sts => sts.engagementStatus === 'Eligible'
              );
            }

            if (this.isC3CustomerBool === true) {
              this.eligibleEng = this.engagements.filter(
                sts =>
                  sts.engagementStatus === 'Eligible' &&
                  sts.c3Engagement === 'Yes'
              );
            }

            if (
              this.engActivitybyCountry === null ||
              this.engActivitybyCountry.length === 0
            ) {
              this.totalRecordsEngGeography = 0;
              this.currentPageInfoEngGeography = 'No Records Found';
            } else {
              this.totalRecordsEngGeography = this.engActivitybyCountry.length;
              if (
                this.totalRecordsEngGeography > 0 &&
                this.totalRecordsEngGeography > 15
              ) {
                this.currentPageInfoEngGeography =
                  'Showing 1 - ' +
                  1 * 15 +
                  ' of ' +
                  this.totalRecordsEngGeography +
                  ' Records';
              }
              if (
                this.totalRecordsEngGeography > 0 &&
                this.totalRecordsEngGeography <= 15
              ) {
                this.currentPageInfoEngGeography =
                  'Showing 1 - ' +
                  this.totalRecordsEngGeography +
                  ' of ' +
                  this.totalRecordsEngGeography +
                  ' Records';
              }
            }

            if (
              this.engActivitybyCountryEligible === null ||
              this.engActivitybyCountryEligible.length === 0
            ) {
              this.totalRecordsEngGeographyEligible = 0;
              this.currentPageInfoEngGeographyEligible = 'No Records Found';
            } else {
              this.totalRecordsEngGeographyEligible =
                this.engActivitybyCountryEligible.length;
              if (
                this.totalRecordsEngGeographyEligible > 0 &&
                this.totalRecordsEngGeographyEligible > 15
              ) {
                this.currentPageInfoEngGeographyEligible =
                  'Showing 1 - ' +
                  1 * 15 +
                  ' of ' +
                  this.totalRecordsEngGeographyEligible +
                  ' Records';
              }
              if (
                this.totalRecordsEngGeographyEligible > 0 &&
                this.totalRecordsEngGeographyEligible <= 15
              ) {
                this.currentPageInfoEngGeographyEligible =
                  'Showing 1 - ' +
                  this.totalRecordsEngGeographyEligible +
                  ' of ' +
                  this.totalRecordsEngGeographyEligible +
                  ' Records';
              }
            }

            if (this.eligibleEng === null || this.eligibleEng.length === 0) {
              this.totalRecordsEligibleEng = 0;
              this.currentPageInfoEligible = 'No Records Found';
            } else {
              this.totalRecordsEligibleEng = this.eligibleEng.length;
              if (
                this.totalRecordsEligibleEng > 0 &&
                this.totalRecordsEligibleEng > 15
              ) {
                this.currentPageInfoEligible =
                  'Showing 1 - ' +
                  1 * 15 +
                  ' of ' +
                  this.totalRecordsEligibleEng +
                  ' Records';
              }
              if (
                this.totalRecordsEligibleEng > 0 &&
                this.totalRecordsEligibleEng <= 15
              ) {
                this.currentPageInfoEligible =
                  'Showing 1 - ' +
                  this.totalRecordsEligibleEng +
                  ' of ' +
                  this.totalRecordsEligibleEng +
                  ' Records';
              }
            }

            if (this.isC3CustomerBool === false) {
              this.approvedEng = this.engagements.filter(
                sts => sts.engagementStatus === 'Approved'
              );
            }
            if (this.isC3CustomerBool === true) {
              this.approvedEng = this.engagements.filter(
                sts =>
                  sts.engagementStatus === 'Approved' &&
                  sts.c3Engagement === 'Yes'
              );
            }
            if (this.approvedEng === null || this.approvedEng.length === 0) {
              this.totalRecordsApprovedEng = 0;
              this.currentPageInfoApproved = 'No Records Found';
            } else {
              this.totalRecordsApprovedEng = this.approvedEng.length;
              if (
                this.totalRecordsApprovedEng > 0 &&
                this.totalRecordsApprovedEng > 15
              ) {
                this.currentPageInfoApproved =
                  'Showing 1 - 15' +
                  ' of ' +
                  this.totalRecordsApprovedEng +
                  ' Records';
              }
              if (
                this.totalRecordsApprovedEng > 0 &&
                this.totalRecordsApprovedEng <= 15
              ) {
                this.currentPageInfoApproved =
                  'Showing 1 - ' +
                  this.totalRecordsApprovedEng +
                  ' of ' +
                  this.totalRecordsApprovedEng +
                  ' Records';
              }
            }
            this.getPartnerFundStatus(
              this.srchEngagements.controls['txtEngagementSrch'].value
            );
            this.getEngagementActivityStatus(
              this.srchEngagements.controls['txtEngagementSrch'].value
            );
          }
        });

      this.formPartnerCompliance.controls['isMcapBlocked'].setValue({
        statusValue: this.partnerComplianceDetail.find(
          p => p.programTypeId == this.programType.Accelerator
        )?.isBlocked,
        statusName: this.blockStatus.find(
          obj =>
            obj.statusValue ==
            this.partnerComplianceDetail.find(
              p => p.programTypeId == this.programType.Accelerator
            )?.isBlocked
        )?.statusName
      });
      this.loading = false;
    }
  }

  getFiscalYear() {
    this.ds.getFiscalYear().subscribe(x => {
      this.fiscalYear = x;
    });
  }

  getPartnerPaymentDetails(commonInputModel: CommonInputModel) {
    this.ds
      .getPartnerAndPaymentDetails(commonInputModel)
      .subscribe(partnerPaymentDetails => {
        this.partnerPaymentDetails = partnerPaymentDetails;
        if (this.partnerPaymentDetails !== null) {
          this.showPartnerPaymentInfo = true;
        }
      });
  }

  checkInput() {
    const srch = this.srchEngagements.controls['txtEngagementSrch'].value;
    if (srch === '' || srch === undefined) {
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please enter PartnerID'
      } as any);
      this.disableSrchButton = true;
    } else if (srch !== '' || srch !== undefined) {
      this.disableSrchButton = false;
    }
  }

  editRequestDetails(event, id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.requestDetailId = id;
    this.engagementIdPassToChild = id;
    this.engagementEditInput = {
      engagementId: id
    } as EngagementEditInput;

    if (this.editNavChild) {
      this.editNavChild.fillEditValues(id);
    }
  }

  refresh() {
    this.refreshList.emit(true);
  }

  fillUser(id: string) {
    this.getByRequestDetails(id);
  }

  getByRequestDetails(tpId) {
    this.osm.getFactDataByRequestDetails(tpId).subscribe(getByReqId => {
      return getByReqId;
    });
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  refreshPartnerPaymentDetails(event: any) {
    const commonInputModel: CommonInputModel = {
      mpnid: this.searchedMpnId.toString(),
      programTypeId: event.programType,
      year: event.finYear
    };
    this.getPartnerPaymentDetails(commonInputModel);
    this.getFiscalYear();
  }

  onLoadProgramType() {
    this.programTypes = [
      { programTypeName: 'MSSP', programTypeId: 2 },
      { programTypeName: 'Operator', programTypeId: 3 },
      { programTypeName: 'Events', programTypeId: 4 }
    ];
  }

  onLoadStatusForConcierge() {
    this.ds.getConciergeStatus().subscribe(data => {
      this.conciergeStatuses = data;
      this.getAllConciergeData();
    });
  }

  editConciergeInfo() {
    this.msgs = [];
    this.isEditConcierge = true;
    this.formConcierge.enable();
  }

  cancelConciergeInfo() {
    this.isEditConcierge = false;
    this.resetFormConcierge();
    this.getAllConciergeData();
    this.formConcierge.disable();
  }

  saveConciergeInfo() {
    let temp: UpdateConciergeRequest;

    temp = {
      mpnId: this.searchedMpnId,
      programTypeId: ProgramTypes.MSSP,
      engagementDate: this.formConcierge.controls['conciergeDateMSSP'].value,
      conciergeStatusId:
        this.formConcierge.controls['conciergeStatusMSSP'].value == null
          ? null
          : this.formConcierge.controls['conciergeStatusMSSP'].value
              .conciergeStatusId
    };

    this.conciergeData.push(temp);

    temp = {
      mpnId: this.searchedMpnId,
      programTypeId: ProgramTypes.Operator,
      engagementDate:
        this.formConcierge.controls['conciergeDateOperator'].value,
      conciergeStatusId:
        this.formConcierge.controls['conciergeStatusOperator'].value == null
          ? null
          : this.formConcierge.controls['conciergeStatusOperator'].value
              .conciergeStatusId
    };

    this.conciergeData.push(temp);

    temp = {
      mpnId: this.searchedMpnId,
      programTypeId: ProgramTypes.Events,
      engagementDate: this.formConcierge.controls['conciergeDateEvents'].value,
      conciergeStatusId:
        this.formConcierge.controls['conciergeStatusEvents'].value == null
          ? null
          : this.formConcierge.controls['conciergeStatusEvents'].value
              .conciergeStatusId
    };

    this.conciergeData.push(temp);

    this.ds.saveAllConciergeData(this.conciergeData).subscribe(() => {
      this.conciergeData = [];
      this.isEditConcierge = false;
      this.isDisableSaveConcierge = true;
      this.formConcierge.disable();
    });
  }

  getConciergeInformation() {
    this.onLoadStatusForConcierge();
  }

  getAllConciergeData() {
    this.ds.getAllConciergeData(this.searchedMpnId).subscribe(data => {
      this.showConcierge = true;
      this.isDisableSaveConcierge = true;
      const datePipe = new DatePipe('en-US');
      if (data != null) {
        data.map(program => {
          if (program.programTypeId === ProgramTypes.Operator) {
            const conciergeDate = datePipe.transform(
              program.engagementDate,
              'MM/dd/yyyy'
            );
            this.formConcierge.controls['conciergeDateOperator'].setValue(
              conciergeDate
            );
            const status = this.conciergeStatuses.filter(
              i => i.conciergeStatusId == program.conciergeStatusId
            )[0];
            this.formConcierge.controls['conciergeStatusOperator'].setValue(
              status
            );
          }

          if (program.programTypeId === ProgramTypes.MSSP) {
            const conciergeDate = datePipe.transform(
              program.engagementDate,
              'MM/dd/yyyy'
            );
            this.formConcierge.controls['conciergeDateMSSP'].setValue(
              conciergeDate
            );
            const status = this.conciergeStatuses.filter(
              i => i.conciergeStatusId == program.conciergeStatusId
            )[0];
            this.formConcierge.controls['conciergeStatusMSSP'].setValue(status);
          }

          if (program.programTypeId === ProgramTypes.Events) {
            const conciergeDate = datePipe.transform(
              program.engagementDate,
              'MM/dd/yyyy'
            );
            this.formConcierge.controls['conciergeDateEvents'].setValue(
              conciergeDate
            );
            const status = this.conciergeStatuses.filter(
              i => i.conciergeStatusId == program.conciergeStatusId
            )[0];
            this.formConcierge.controls['conciergeStatusEvents'].setValue(
              status
            );
          }
        });
      } else {
        this.formConcierge.patchValue({
          conciergeDateOperator: null,
          conciergeStatusOperator: null,
          conciergeDateMSSP: null,
          conciergeStatusMSSP: null,
          conciergeDateEvents: null,
          conciergeStatusEvents: null
        });
      }
    });
  }

  resetFormConcierge() {
    this.formConcierge.patchValue({
      programType: null,
      conciergeDate: null,
      conciergeStatus: null
    });
  }

  onProgramTypeChange() {
    this.getAllConciergeData();
  }

  onConciergeChange() {
    this.isDisableSaveConcierge = false;
  }

  onConciergeStatusChange() {
    this.isDisableSaveConcierge = false;
  }

  editPartnerComplianceInfo() {
    this.msgsEngDetails = [];
    this.isEditPartnerCompliance = true;
    this.formPartnerCompliance.enable();
  }

  editPartnerWorkshopAllocation() {
    this.isEditPartnerOneAllocation = !this.isEditPartnerOneAllocation;
  }

  onCancelEditPartnerCompliance() {
    this.loadingCompliance = true;
    this.msgsEngDetails = [];
    this.isSaveComplianceDisabled = true;
    this.isEditPartnerCompliance = false;
    this.formPartnerCompliance.disable();
    this.onPartnerComplianceFormGroup();
  }

  onCancelEditPartnerAllocation() {
    this.getPartnerOneAreas();
    this.getCurrentFiscalYearAndQuarter();
    this.getEventTypes();
    this.isEditPartnerOneAllocation = !this.isEditPartnerOneAllocation;
  }

  resetPartnerCompliance() {
    this.isMcapBlocked =
      this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Accelerator
      )?.isBlocked || false;
    this.isOperatorBlocked =
      this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Operator
      )?.isBlocked || false;
    this.isMsspBlocked =
      this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.MSSP
      )?.isBlocked || false;
    this.isEventsBlocked =
      this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Events
      )?.isBlocked || false;
  }
  get IsBlockeReasonNotSelected(): boolean {
    return this.partnerComplianceDetail.some(
      p =>
        p.isBlocked &&
        (p.blockPartnerReasonId == null || p.blockPartnerReasonId == 0)
    );
  }

  onSavePartnerCompliance() {
    this.loadingCompliance = true;
    this.ds
      .addPartnerComplianceInformation(this.partnerComplianceDetail)
      .subscribe(() => {
        this.onCancelEditPartnerCompliance();
      });
  }

  onSavePartnerAllocation() {
    this.isEditPartnerOneAllocation = !this.isEditPartnerOneAllocation;
  }

  onMcapBlockStatusChange(event) {
    this.isSaveComplianceDisabled = false;
    this.isMcapBlocked = event.value.statusValue;

    const acceleratorDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.Accelerator
    );

    if (acceleratorDetail) {
      acceleratorDetail.isBlocked = this.isMcapBlocked;
    }

    if (!this.isMcapBlocked) {
      this.formPartnerCompliance.controls['mcapBlockReason'].setValue({
        reasonDescription: '',
        blockPartnerReasonId: 0
      });

      const acceleratorDetail = this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Accelerator
      );

      if (acceleratorDetail) {
        acceleratorDetail.blockPartnerReasonId = 0;
      }
    }
  }

  onOperatorBlockStatusChange(event) {
    this.isSaveComplianceDisabled = false;
    this.isOperatorBlocked = event.value.statusValue;

    const operatorDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.Operator
    );

    if (operatorDetail) {
      operatorDetail.isBlocked = this.isOperatorBlocked;
    }

    if (!this.isOperatorBlocked) {
      this.formPartnerCompliance.controls['operatorBlockReason'].setValue({
        reasonDescription: '',
        blockPartnerReasonId: 0
      });

      const operatorDetail = this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Operator
      );

      if (operatorDetail) {
        operatorDetail.blockPartnerReasonId = 0;
      }
    }
  }

  onMsspBlockStatusChange(event) {
    this.isSaveComplianceDisabled = false;
    this.isMsspBlocked = event.value.statusValue;

    const msspDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.MSSP
    );

    if (msspDetail) {
      msspDetail.isBlocked = this.isMsspBlocked;
    }

    if (!this.isMsspBlocked) {
      this.formPartnerCompliance.controls['msspBlockReason'].setValue({
        reasonDescription: '',
        blockPartnerReasonId: 0
      });

      const msspDetail = this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.MSSP
      );

      if (msspDetail) {
        msspDetail.blockPartnerReasonId = 0;
      }
    }
  }

  onEventsBlockStatusChange(event) {
    this.isSaveComplianceDisabled = false;
    this.isEventsBlocked = event.value.statusValue;

    const eventDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.Events
    );

    if (eventDetail) {
      eventDetail.isBlocked = this.isEventsBlocked;
    }

    if (!this.isEventsBlocked) {
      this.formPartnerCompliance.controls['eventsBlockReason'].setValue({
        reasonDescription: '',
        blockPartnerReasonId: 0
      });

      const eventDetail = this.partnerComplianceDetail.find(
        p => p.programTypeId == this.programType.Events
      );

      if (eventDetail) {
        eventDetail.blockPartnerReasonId = 0;
      }
    }
  }

  onMcapBlockReasonChange(event) {
    this.isSaveComplianceDisabled = false;

    const acceleratorDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.Accelerator
    );

    if (acceleratorDetail) {
      acceleratorDetail.blockPartnerReasonId = event.value.blockPartnerReasonId;
    }
  }

  onMsspBlockReasonChange(event) {
    this.isSaveComplianceDisabled = false;

    const msspDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.MSSP
    );

    if (msspDetail) {
      msspDetail.blockPartnerReasonId = event.value.blockPartnerReasonId;
    }
  }

  onOperatorBlockReasonChange(event) {
    this.isSaveComplianceDisabled = false;

    const operatorDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.Operator
    );

    if (operatorDetail) {
      operatorDetail.blockPartnerReasonId = event.value.blockPartnerReasonId;
    }
  }

  onEventsBlockReasonChange(event) {
    this.isSaveComplianceDisabled = false;

    const eventDetail = this.partnerComplianceDetail.find(
      p => p.programTypeId == this.programType.Events
    );

    if (eventDetail) {
      eventDetail.blockPartnerReasonId = event.value.blockPartnerReasonId;
    }
  }
  get programType() {
    return ProgramTypes;
  }

  checkForComplianceErrorMessage(isBlocked: boolean, reason: any) {
    if (isBlocked && reason == '' && this.isEditPartnerCompliance) {
      return 'Blocked reason is required when Status is Blocked';
    } else {
      return '';
    }
  }

  get isBlockReasonSelected() {
    if (
      (this.isMcapBlocked &&
        this.formPartnerCompliance.controls['mcapBlockReason'].value
          .reasonDescription == '') ||
      (this.isOperatorBlocked &&
        this.formPartnerCompliance.controls['operatorBlockReason'].value
          .reasonDescription == '') ||
      (this.isMsspBlocked &&
        this.formPartnerCompliance.controls['msspBlockReason'].value
          .reasonDescription == '') ||
      (this.isEventsBlocked &&
        this.formPartnerCompliance.controls['eventsBlockReason'].value
          .reasonDescription == '')
    ) {
      return false;
    }
    return true;
  }

  getCurrentFiscalYear() {
    const currentDate = new Date();
    if (currentDate.getMonth() < 6) {
      return currentDate.getFullYear();
    }
    return currentDate.getFullYear() + 1;
  }
}
